module.exports = __webpack_public_path__ + "img/IMG_9698_1.de74eb46.jpeg";